import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Respectful Markets — official PNG logo (uploaded by client).
 *
 * Variants:
 *   - <LogoMark />  → small navbar version (image only, transparent bg)
 *   - <Logo />      → mark + invisible Link wrapper, used in nav/footer
 *
 * The PNG sits in /public/rm-logo-nav.png (transparent background).
 * For dark backgrounds (footer), pass theme="light" — the component then
 * wraps the logo in a soft white pill so the navy text stays legible.
 */

export const LogoMark = ({ size = 44, theme = 'teal', className = '' }) => {
  // size = pixel height of the logo image
  const isDark = theme === 'light'; // 'light' = on dark bg → wrap in white pill
  const img = (
    <img
      src="/rm-logo-nav.png"
      alt="Respectful Markets — The Conscious Marketplace"
      style={{ height: size, width: 'auto', display: 'block' }}
      className={isDark ? '' : className}
      loading="eager"
      decoding="async"
    />
  );

  if (isDark) {
    return (
      <span
        className={`inline-flex items-center bg-white rounded-xl px-3 py-1.5 shadow-sm ${className}`}
        style={{ height: size + 12 }}
      >
        {img}
      </span>
    );
  }
  return img;
};

export const Logo = ({ size = 44, theme = 'teal', className = '', to = '/' }) => {
  const content = <LogoMark size={size} theme={theme} className={className} />;
  if (to) {
    return (
      <Link to={to} data-testid="logo-link" className="inline-flex items-center">
        {content}
      </Link>
    );
  }
  return content;
};

export default Logo;
